/**
 * Custom markdown syntax for clickable options:
 * [[Option text here]]
 * [[@{{"text": "Page", "type": "page", "id": "123"}}]]
 *
 * This renders as a clickable span that can trigger message sending
 * Can contain plain text or mentions
 */

const clickableOptionRegex = /\[\[.*?\]\]/;
const clickableOptionTokenizer = /^\[\[(.*?)\]\]/;

/**
 * A marked extension for rendering the custom markdown syntax for clickable options to html
 */
export const extensionClickableOption = {
    name: 'clickableOption',
    level: 'inline',
    start: (src) => {
        const match = src.search(clickableOptionRegex);

        return match === -1 ? undefined : match;
    },
    tokenizer (src) {
        const match = clickableOptionTokenizer.exec(src);
        if (!match) return;

        const innerContent = match[1];

        // Let marked process the inner content for mentions and other inline elements
        const token = {
            type: 'clickableOption',
            raw: match[0],
            text: innerContent,
            tokens: [],
        };

        // Parse inner content to handle mentions
        this.lexer.inline(innerContent, token.tokens);

        return token;
    },
    renderer (token) {
        // Get the plain text for data-text attribute
        const plainText = token.text;
        // Render the processed inner tokens (which may include mentions)
        const renderedContent = this.parser.parseInline(token.tokens);

        return `<span class="clickable-option" data-text="${escapeHtml(plainText)}">${renderedContent}</span>`;
    },
};

function escapeHtml (text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
}

